export default {
  iotRow1: '基于杰为平台，制造商能够从资产、设备和机器中搜集汇总数据，并将数据转换为智能操作，可立即人工执行或自动运作，以提高运行效率，降低成本。通过联接信息技术、运行技术和知识产权资产，客户能够加强自动化，尽量减少干预，以无中断方式运行，实现工业物联网价值最大化'
}
